import Animation from '../../animations/animation'
import * as d3 from 'd3-selection'
import StyleTweeners from '../style-tweeners'

class UnsplitAreas extends Animation {

  constructor (options) {
    super(options)
    this.styleTweeners = new StyleTweeners(this.styles)
  }

  match (serie) {
    // TODO this is copied from unsplit-line
    if (!this.previous.scalers.x || !this.seriesChanged) {
      // We don't have previous data or series didn't change
      return false
    }

    let ticks0 = this.previous.scalers.x.groupScale.domain()
      , ticks1 = this.scalers.x.groupScale.domain()
      , newSeries = this.series.filter(serie => {
        return this.previous.series.data().indexOf(serie) === -1 // We didn't have this serie previously
      })

    return ticks0.length === ticks1.length && // Same tick count on bottom
           this.exitingSeries.size() > 1 && // More than one serie being removed
           newSeries.size() === 1 // One new serie
  }

  animate (serie, entering, selection, merged, exiting) {
    if (entering.size()) {
      // Single new line entering
      // This is the new line. Let's get it in the DOM at its final location
      this._insertPaths(entering)
      this._points(entering)

      merged.tween('shrink-stroke', this.styleTweeners.shrinkStroke(merged))
            .tween('fade-in', this.styleTweeners.fadeIn(merged, true))

      let styleTweeners = this.styleTweeners
        , yScale = this.yScale
        , xScale = this.scalers.x.center
        , pathAdjuster = this.pathAdjuster

      // Now take all the exiting series and have them converge to the new line
      this.exitingSeries.each(function (exitingSerie) {
        let transition = d3.select(this).transition(merged) // inherit merge transition
          , newPoints = entering.datum().points
          , scalers = {
            x: xScale,
            y: (raw, d) => {
              let point = newPoints.find(p => p.rangeId === d.rangeId)
              return yScale(point.raw)
            }
          }

        // Move the exiting paths
        pathAdjuster.transitionPathTo(exitingSerie.points, transition, scalers.x, scalers.y)

        transition.tween('piecewise-stroke', styleTweeners.piecewiseStroke(transition))
                  .tween('fade-out', styleTweeners.fadeOut(transition))
      })
    } else if (!exiting.size()) {
      // update old series in case scale changed
      this._updateDrawing(merged)
    }
  }

}

export default UnsplitAreas
